import React from 'react';
import ProfileNavBar from '../ProfileNavBar/ProfileNavBar';
import './ProfileMenu.scss';
import DeviceContext from '../../Services/identifyDevice';
// import { useHistory } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import GlobalStore from '../../store/globalStore';
import ProgressBar from '../../UI/ProgressBar/ProgressBar';
import { dashboardUrl } from '../../utils/constants';
import { calculateCompletePercentage } from '../../Services/globalService';
import logo from '../../../assets/icons/edel_icons/Nuvama_Identity_RGB_Positive.jpg';

export interface ProfileMenuProps {
}

const ProfileMenu: React.FC<ProfileMenuProps> = () => {

    // const history = useHistory();
    const navigate = useNavigate()

    React.useEffect(() => {
        if (DeviceContext().isDesktop) {
            if (GlobalStore.dashboardDefaultUrl)
                // history.replace(GlobalStore.dashboardDefaultUrl);
            navigate(GlobalStore.dashboardDefaultUrl, { replace: true })
            else
                // history.replace(dashboardUrl.profile);
            navigate(dashboardUrl.profile, { replace: true })
        }
    // }, [history.location.pathname]);
    }, [window.location.pathname]);

    const percentageComplete: string = calculateCompletePercentage();
    const progressLabelId = 'profile-menu-progress-label';

    return (
        <div className='prfMenu'>
            <div className='prfMenuLogo'>
                <img className='Logo-main' src={logo} alt="Nuvama logo" />
                <div className='progBar'>
                    <ProgressBar
                      percent={percentageComplete}
                      width='120px'
                      height='4px'
                      ariaLabelledBy={progressLabelId}
                    />
                </div>
                <div className='progPercent'>
                    <span id={progressLabelId}>{percentageComplete}% complete</span>
                </div>
            </div>
            <nav className='menuList' aria-label="Mobile application navigation">
                <ProfileNavBar />
            </nav>
        </div>
    )
}

export default ProfileMenu;
